import React, { useEffect, useRef } from 'react';
import StopCard from './StopCard';

const NO_SELECTION = [];

export default function StopsList({ stops, onFocusStop, showCompany, selectedStopIds = NO_SELECTION }) {
  const listRef = useRef(null);
  const firstSelectedId = selectedStopIds[0];

  // When the map selects stops (several at one place, for instance), bring the first one into
  // view. scrollIntoView doesn't exist in jsdom, hence the guard.
  useEffect(() => {
    if (!firstSelectedId || !listRef.current) return;

    const card = listRef.current.querySelector(`[data-stop-id="${firstSelectedId}"]`);
    if (card && typeof card.scrollIntoView === 'function') {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [firstSelectedId]);

  return (
    <div data-testid="stops-list" ref={listRef}>
      {stops.map((stop) => (
        <StopCard
          key={stop.id}
          stop={stop}
          onFocusStop={onFocusStop}
          showCompany={showCompany}
          selected={selectedStopIds.includes(stop.id)}
        />
      ))}
    </div>
  );
}
